import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class Collapse extends React.Component {
    constructor(props) {
        super(props);
        this.height = 0;
        this.disable = false;
        this.hanldeToggleCollapse = () => {
            this.handleItemClick();
        };
        this.handleItemClick = () => {
            if (this.disable || !this.$panelCon)
                return;
            this.disable = true;
            const node = this.$panelCon;
            // animation
            const active = !this.state.isActive;
            node.style.height = `${active ? this.height : 0}px`;
            // end
            setTimeout(() => {
                this.disable = false;
                node.style.height = `${active ? '' : 0}`;
                // 高度修正
                if (node && active) {
                    this.height = node.offsetHeight;
                    node.style.height = `${this.height}px`;
                }
            }, 300);
            this.props.onChange && this.props.onChange(active);
            this.setState({ isActive: active });
        };
        this.titleContent = () => {
            const { title, showArrow } = this.props;
            return (<div className='cfm_collapse_title' onClick={this.handleItemClick}>
        {title ? <div className='cfm_collapse_title_inner'>{title}</div> : null}
        {showArrow
                ? <span className='cfm_collapse_icon_wrap'>
              <Icon size='xs' className='cfm_collapse_icon' type='down'/>
            </span>
                : null}
      </div>);
        };
        this.initHidden = !props.isActive,
            this.state = {
                isActive: props.isActive,
                preActive: props.isActive,
                contentStyle: {
                    display: props.isActive ? 'block' : 'none',
                },
            };
    }
    componentDidUpdate(preProps) {
        if (preProps.isActive !== this.props.isActive &&
            this.props.isActive !== this.state.isActive) {
            this.hanldeToggleCollapse();
        }
    }
    componentDidMount() {
        const node = this.$panelCon;
        if (!node)
            return;
        this.height = node.offsetHeight;
        if (!this.props.isActive) {
            node.style.height = '0';
        }
        else {
            node.style.height = `${this.height}px`;
        }
    }
    render() {
        const { className, contentClassName, style, titlePosition, children, title } = this.props;
        const { isActive } = this.state;
        const coCls = classnames('cfm_collapse', `cfm_collapse_${titlePosition}`, {
            'cfm_collapse_active': isActive,
        }, className);
        return (<div className={coCls} style={style}>
        {titlePosition === 'top' && title ? this.titleContent() : null}
        <div ref={el => (this.$panelCon = el)} className={classnames('cfm_collapse_content', contentClassName)}>
          {children}
        </div>
        {titlePosition === 'bottom' && title ? this.titleContent() : null}
      </div>);
    }
}
Collapse.defaultProps = {
    title: null,
    titlePosition: 'top',
    style: {},
    isActive: false,
    showArrow: true,
};
export default Collapse;



// WEBPACK FOOTER //
// ./components/collapse/index.tsx